import { useQuery } from "@tanstack/react-query";
import { ProvidersByNetworkAndVolumeData } from "@app/overviews/network-benchmarking-dashboard/tiles/shared";
import { NetworkComparisonFiltersPayload } from "@app/overviews/network-benchmarking-dashboard/filters/network-comparison-filters/shared/NetworkComparisonFiltersPayload";
import { BenchmarkingServiceType } from "@app/overviews/network-benchmarking-dashboard/filters/shared/utility";

export interface ProvidersByNetworkAndVolumeDataResult {
  providersByNetworkAndVolumeData: ProvidersByNetworkAndVolumeData[];
  providersByNetworkAndVolumeDataLoading: boolean;
}

export const PROVIDERS_BY_NETWORK_AND_VOLUME_DATA_QUERY_KEY_PREFIX = "benchmarking-providers-by-network-and-volume-data";

export const useProvidersByNetworkAndVolumeData = (
  service: BenchmarkingServiceType,
  payload: NetworkComparisonFiltersPayload | null
): ProvidersByNetworkAndVolumeDataResult => {
  const queryResult = useQuery<ProvidersByNetworkAndVolumeData[]>({
    enabled: !!payload,
    queryFn: ({ signal }) => service.getProvidersByNetworkAndVolumeData(payload, signal),
    queryKey: [PROVIDERS_BY_NETWORK_AND_VOLUME_DATA_QUERY_KEY_PREFIX, service?.lineOfBusiness, JSON.stringify(payload)],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    providersByNetworkAndVolumeData: queryResult.data ?? [],
    providersByNetworkAndVolumeDataLoading: queryResult.isFetching,
  };
}

export default useProvidersByNetworkAndVolumeData;
